import { msg } from '@lingui/core/macro';

export const SHARED_ACCOUNT_LOCKED_TITLE = msg`Account locked`;
export const SHARED_ACCOUNT_LOCKED_RESET_PASSWORD = msg`Reset password`;
export const SHARED_ACCOUNT_LOCKED_MINUTE = msg`minute`;
export const SHARED_ACCOUNT_LOCKED_MINUTES = msg`minutes`;
export const SHARED_ACCOUNT_LOCKED_WAIT = msg`Wait`;
